// src/mathLogic.js
import { getRng } from './utils/random';

export const generateMathQuiz = (count = 20, difficulty = 'medium', seed = null) => {
  const rng = getRng(seed); // تفعيل المولد العشوائي الموجه
  const questions = [];

  for (let i = 0; i < count; i++) {
    let num1, num2, operator, answer;
    
    // 1. تحديد نوع العملية حسب الصعوبة
    const ops = ['+', '-'];
    
    // فالمستوى المتوسط والصعب كنزيدو الضرب
    if (difficulty === 'medium' || difficulty === 'hard') {
      ops.push('*'); 
    }
    
    operator = ops[Math.floor(rng() * ops.length)];

    // 2. تحديد الحد الأقصى للأرقام
    // Easy: حتى لـ 20
    // Medium: حتى لـ 50
    // Hard: حتى لـ 100
    let max = difficulty === 'easy' ? 20 : difficulty === 'medium' ? 50 : 100;
    
    // استثناء: فالضرب، كنصغرو الأرقام باش مايكونش الحساب معقد بزاف
    if (operator === '*') {
       max = difficulty === 'hard' ? 15 : 10;
    }

    // توليد الرقمين
    num1 = Math.floor(rng() * max) + 1;
    num2 = Math.floor(rng() * max) + 1;

    // 3. تصحيح الطرح (Subtraction Logic)
    // خاصنا ديما الرقم الكبير هو الأول باش مايخرجش سالب (للأطفال)
    if (operator === '-' && num1 < num2) {
      [num1, num2] = [num2, num1]; // قلبناهم
    }

    // 4. حساب الجواب
    if (operator === '+') answer = num1 + num2;
    if (operator === '-') answer = num1 - num2;
    if (operator === '*') answer = num1 * num2;

    questions.push({ 
      id: i, 
      num1, 
      num2, 
      operator, 
      answer 
    });
  }

  return questions;
};